
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Crown, Loader2 } from "lucide-react";

const AdminReactivateButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const reactivateAdminAccount = async () => {
    setIsLoading(true);
    
    try {
      // Find and update the admin account
      const { data: user, error: findError } = await supabase
        .from('profiles')
        .select('*')
        .eq('email', 'aipalpiteguru@gmail.com')
        .single();

      if (findError) {
        console.error('Error finding admin account:', findError);
        toast({
          title: "Erro",
          description: "Conta de administrador não encontrada.",
          variant: "destructive",
        });
        return;
      }

      // Restore admin privileges with full access
      const { error: updateError } = await supabase
        .from('profiles')
        .update({
          role: 'admin',
          plan: 'vip',
          is_subscribed: true,
          billing_period: 'annual',
          subscription_end_date: new Date(new Date().setFullYear(new Date().getFullYear() + 10)).toISOString(),
          last_payment_date: new Date().toISOString(),
          last_payment_status: 'succeeded',
          updated_at: new Date().toISOString()
        })
        .eq('email', 'aipalpiteguru@gmail.com');

      if (updateError) {
        console.error('Error updating admin account:', updateError);
        toast({
          title: "Erro",
          description: `Erro ao restaurar conta de administrador: ${updateError.message}`,
          variant: "destructive",
        });
        return;
      }

      toast({
        title: "✅ Conta de Administrador Restaurada!",
        description: "aipalpiteguru@gmail.com foi restaurada com todos os privilégios de administrador e acesso VIP.",
      });

    } catch (error) {
      console.error('Error in admin reactivation:', error);
      toast({
        title: "Erro",
        description: "Erro interno ao restaurar conta de administrador.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-gradient-to-r from-red-50 to-orange-50 dark:from-red-900/20 dark:to-orange-900/20 border-2 border-red-300 dark:border-red-600 rounded-lg p-6 mb-6">
      <h3 className="font-semibold text-red-800 dark:text-red-200 mb-4 flex items-center gap-2">
        <Crown className="w-5 h-5" />
        🚨 Restauração de Conta de Administrador
      </h3>
      <div className="flex flex-wrap gap-4">
        <Button
          onClick={reactivateAdminAccount}
          disabled={isLoading}
          className="bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white font-semibold shadow-lg"
        >
          {isLoading ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Restaurando...
            </>
          ) : (
            <>
              <Crown className="w-4 h-4 mr-2" />
              🔧 Restaurar Admin: aipalpiteguru@gmail.com
            </>
          )}
        </Button>
      </div>
      <p className="text-sm text-red-600 dark:text-red-400 mt-3">
        <strong>Ação Crítica:</strong> Restaurar conta de administrador com todos os privilégios e acesso VIP permanente
      </p>
    </div>
  );
};

export default AdminReactivateButton;
